import { del, get, post } from '../../api';

export const getNotificacaoEmails = () => {
  return get('/api/conectores/notificacao/emails');
};

export const getNotificacaoEmail = (id) => {
  return get(`/api/conectores/notificacao/email/${id}`);
};

export const postNotificacaoEmail = (data) => {
  return post('/api/conectores/notificacao/email', data);
};

export const deleteNotificacaoEmail = (id) => {
  return del(`/api/conectores/notificacao/email/${id}`);
};
